import React from 'react';
import { Box, FormControlLabel, Stack, Switch, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import Panel from './Panel';

export const THINKING_LEVELS = ['low', 'medium', 'high'];

const ModelControls = ({ settings, onChange, disabled }) => {
    const set = (key, value) => onChange({ ...settings, [key]: value });

    return (
        <Panel title="What the model is given" sx={{ mb: 3 }}>
            <Stack spacing={1.5}>
                <FormControlLabel
                    label="Spell out the legal cells"
                    control={(
                        <Switch
                            size="small"
                            checked={settings.hintLegalMoves}
                            onChange={(event) => set('hintLegalMoves', event.target.checked)}
                            disabled={disabled}
                        />
                    )}
                />

                <FormControlLabel
                    label="Fall back to smaller models"
                    control={(
                        <Switch
                            size="small"
                            checked={settings.fallback}
                            onChange={(event) => set('fallback', event.target.checked)}
                            disabled={disabled}
                        />
                    )}
                />

                <Box>
                    <Typography variant="body2" color="text.secondary" gutterBottom>Thinking budget</Typography>
                    <ToggleButtonGroup
                        exclusive
                        fullWidth
                        size="small"
                        value={settings.thinkingLevel}
                        onChange={(event, next) => next && set('thinkingLevel', next)}
                        disabled={disabled}
                        aria-label="Thinking budget"
                    >
                        {THINKING_LEVELS.map((level) => (
                            <ToggleButton key={level} value={level}>{level}</ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </Box>
            </Stack>

            <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 1.5 }}>
                Change these between moves and watch the token count below.
            </Typography>
        </Panel>
    );
};

export default ModelControls;
